import roles from '@/constants/roles';
import { isVue2Administration } from '@/routes/administration';

export const V2_BILLING_REGISTER_PATH = '/administration/aquassistBilling/billingRegister';

// Temporary: AQ Billing isn't built in v3 yet. In production, vue2Administration forwards this path to v2.
export const getPostLoginRoute = (getters: {
    hasRole: (role: string) => boolean;
    defaultUserRoute: string;
}): string =>
    isVue2Administration() && getters.hasRole(roles.FINANCIAL_ADMINISTRATOR.value)
        ? V2_BILLING_REGISTER_PATH
        : getters.defaultUserRoute;
